import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from "vue-router";
import axios from 'axios'
import App from './App.vue'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false
Vue.prototype.$base_url = process.env['VUE_APP_BASEURL']

Vue.use(VueRouter)
Vue.use(Vuex)

import RegistrationPage from "@/pages/registration";
import RaceStatus from "./components/RaceStatus";
import ParticipantSelfService from "./components/ParticipantSelfService"

const routes = [
  { path: '/', component: RaceStatus },
  { path: '/registration', component: RegistrationPage, name: "Registration" },
  { path: '/groups', component: () => import('./pages/group_registration'), name: "GroupRegistration" },
  { path: '/me', component: ParticipantSelfService },
  { path: '/bulk-me', component: () => import('./components/BulkRegistrationSelfService.vue') },
  { path: '/datenschutz', component: () => import('./pages/datenschutz') },
  { path: '/impressum', component: () => import('./pages/impressum') },
  { path: '/login', component: () => import('./components/Login'), name: "Login" },
  { path: '/admin/finance', component: () => import('./components/Finance'), meta: { requiresAuth: true } },
  { path: '/admin/shirts', component: () => import('./components/TShirts'), meta: { requiresAuth: true } },
  { path: '/admin/participants', component: () => import('./components/ParticipantList/ParticipantList'), alias: "/admin", meta: { requiresAuth: true } },
  { path: '/admin/print', component: () => import('./components/Print'), meta: { requiresAuth: true } },
  { path: '/admin/settings', component: () => import('./components/RaceEdit'), meta: { requiresAuth: true } },
  { path: '/admin/mail', component: () => import('./components/mail/MailEditor'), meta: { requiresAuth: true } },
  { path: '/admin/couponcodes', component: () => import('./components/Couponcodes/CouponcodeList'), meta: { requiresAuth: true } },
  { path: '/admin/bulkregistrations', component: () => import('./components/BulkRegistrations/BulkRegistrationList'), meta: { requiresAuth: true } }
];
const router = new VueRouter({ routes })
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      return next({ name: 'Login' })
    }
    return next()
  }

  if (to.name === 'Registration' && !store.getters.raceOpen) {
    return next({ path: '/' })
  }

  if (to.name === 'GroupRegistration' && !store.getters.raceOpen) {
    if (store.getters.isLoggedIn) {
      return next()
    }
    const token = localStorage.pace_token
    if (token) {
      const url = `${process.env.VUE_APP_BASEURL}/login`
      return axios
        .get(url, { headers: { Authorization: `Bearer ${token}` } })
        .then(() => {
          store.commit('setLoggedIn', true)
          next()
        })
        .catch(() => next({ path: '/' }))
    }
    return next({ path: '/' })
  }

  next()
})

const store = new Vuex.Store({
  state: {
    raceOpen: false,
    shirtsEnabled: false,
    isLoggedIn: false
  },
  getters: {
    isLoggedIn: state => {
      return state.isLoggedIn
    },
    raceOpen: state => {
      return state.raceOpen
    }
  },
  mutations: {
    setRaceStatus(state, status) {
      state.raceOpen = status
    },
    setLoggedIn(state, status) {
      state.isLoggedIn = status
    },
    setShirtsEnabled(state, status) {
      state.shirtsEnabled = status
    }
  },
})

new Vue({
  vuetify,
  router,
  store: store,
  render: h => h(App)
}).$mount('#app')
